<template>
  <div>
    <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form class="b-layout" @submit.prevent="">
      <div v-if="operationSelected">
        <div>
          <label>{{ $t('temperatura-na-saida-c') }} </label>
          <input v-model="perdaT.value" type="number" />
          <div></div>
        </div>
        <div>
          <label>{{ $t('pressao-na-saida-bar') }} </label>
          <input v-model="perdaP.value" type="number" />
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      perdaT: {},
      perdaP: {},
      operations: [{ value: null, text:this.$t('selecione-uma-operacao') }],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      const attrList = ["perdaT", "perdaP"];
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => attrList.includes(operation.key));

      this.perdaT = this.operationAttributeList.find(
        (p) => attrList[0] == p.caption
      );

      this.perdaP = this.operationAttributeList.find(
        (p) => attrList[1] == p.caption
      );

      if (this.perdaT) this.perdaT.value = ParseToNumber(this.perdaT.value);
      if (this.perdaP) this.perdaP.value = ParseToNumber(this.perdaP.value);

      this.updateNode();
    },

    "perdaT.value"() {
      this.updateNode();
    },

    "perdaP.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
      }

      this.node.data.forEach((p) => {
        if (p.caption == "perdaT") {
          p.value = ParseToNumber(p.value);
          this.perdaT = p;
        }
        if (p.caption == "perdaP") {
          p.value = ParseToNumber(p.value);
          this.perdaP = p;
        }
      });
    },

    updateNode() {
      let attrs = [
        this.perdaT.clone(),
        this.perdaP.clone()
      ]

      this.node.attrs = attrs;
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) => o.match(/LE/));
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    setTimeout(this.loadNode(), 200);
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}
</style>